<template>
  <span :class="style({ lang })">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';

import type { Lang } from '@/models/lang';

interface Props {
  lang?: Lang;
}

withDefaults(defineProps<Props>(), {
  lang: 'jp',
});

const style = tv({
  base: 'text-red1',
  variants: {
    lang: {
      jp: 'text-xs font-light leading-5 tracking-wider',
      en: 'font-Spectral text-sm font-light tracking-normal',
    },
  },
});
</script>
